import { createRouter, createWebHistory } from 'vue-router'
import { useUser } from '@/composables/useUser'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: { guest: true }
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => import('@/views/ForgetPassword.vue'),
    meta: { guest: true }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/Privacy.vue')
  },
  {
    path: '/expert-service',
    name: 'expert-service',
    component: () => import('@/views/ExpertService.vue')
  },
  {
    path: '/institutions',
    name: 'institutions',
    component: () => import('@/views/Institutions.vue')
  },
  {
    path: '/solutions',
    name: 'solutions',
    component: () => import('@/views/Solutions.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/expert/:id',
    name: 'expert-detail',
    component: () => import('@/views/ExpertDetail.vue')
  },
  {
    path: '/institution/:id',
    name: 'institution-detail',
    component: () => import('@/views/InstitutionDetail.vue')
  },
  {
    path: '/workstation/:id',
    name: 'workstation-detail',
    component: () => import('@/views/WorkstationDetail.vue')
  },
  {
    path: '/mailbox',
    name: 'mailbox',
    component: () => import('@/views/Mailbox.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mailbox/notice',
    name: 'mailbox-notice',
    component: () => import('@/views/Mailbox.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mailbox/write',
    name: 'write-letter',
    component: () => import('@/views/WriteLetter.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/mailbox/detail/:id',
    name: 'mail-detail',
    component: () => import('@/views/MailDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news',
    name: 'news-list',
    component: () => import('@/views/NewsList.vue')
  },
  {
    path: '/news/:id',
    name: 'news-detail',
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    path: '/profile/expert',
    name: 'profile-expert',
    component: () => import('@/views/ProfileExpert.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/expert',
    name: 'apply-expert',
    component: () => import('@/views/ApplyExpert.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/activity',
    name: 'apply-activity',
    component: () => import('@/views/ApplyActivity.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/solution',
    name: 'apply-solution',
    component: () => import('@/views/ApplySolution.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/expert-service',
    name: 'apply-expert-service',
    component: () => import('@/views/ApplyExpertService.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/research-service',
    name: 'apply-research-service',
    component: () => import('@/views/ApplyResearchService.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/success',
    name: 'apply-success',
    component: () => import('@/views/ApplySuccess.vue')
  },
  {
    path: '/apply/institute',
    name: 'apply-institute',
    component: () => import('@/views/ApplyInstitute.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/apply/workstation',
    name: 'apply-workstation',
    component: () => import('@/views/ApplyWorkstation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/workstation',
    name: 'profile-workstation',
    component: () => import('@/views/ProfileWorkstation.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/institute',
    name: 'profile-institute',
    component: () => import('@/views/ProfileInstitute.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/temp/edit/article',
    name: 'temp-article-edit',
    component: () => import('@/views/TempArticleEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/temp/edit/expert',
    name: 'temp-expert-edit',
    component: () => import('@/views/TempExpertEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'search-result',
    component: () => import('@/views/SearchResult.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const { userInfo } = useUser()
  const isLoggedIn = !!userInfo.value

  // 需要登录但未登录，跳登录页
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next('/login')
  }

  // 已登录用户访问登录/注册/找回密码等游客页，跳首页
  if (to.meta.guest && isLoggedIn) {
    return next('/')
  }

  next()
})

export default router
